import { StyleSheet, View, Text } from 'react-native';
import { buildAllergenLegend } from '../constants/Allergens';
import i18n from '../utils/localization';

export default function AllergenLegend({
  products,
  style,
  colorScheme = 'light',
  titleStyle: customTitleStyle,
  labelStyle: customLabelStyle,
  circleSize = 14,
  showTitle = true,
  showBorder = true,
  backgroundColor: customBgColor,
  language = 'original',
}) {
  const legend = buildAllergenLegend(products || []);

  if (legend.length === 0) {
    return null;
  }

  // Translation helper based on language prop
  const translateText = (text) => {
    if (!text) return text;
    if (language === 'original') return text;
    if (language === 'en') return i18n.t(text);
    return text;
  };

  const textColor = colorScheme === 'dark' ? '#FFFFFF' : '#000000';
  const borderColor = colorScheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)';
  // Use customBgColor if provided (including 'transparent'), otherwise use default based on colorScheme
  const defaultBgColor = colorScheme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';
  // Convert 'transparent' to rgba format for better web compatibility
  const bgColor = customBgColor !== undefined
    ? (customBgColor === 'transparent' ? 'rgba(0,0,0,0)' : customBgColor)
    : defaultBgColor;

  // Build container style - ensure backgroundColor is applied last to override any defaults
  const containerStyle = [
    styles.container,
    showBorder ? { borderColor, borderWidth: 1 } : null,
    style,
    { backgroundColor: bgColor },
  ];

  const titleStyleMerged = [
    styles.title,
    { color: textColor },
    customTitleStyle,
  ];

  const labelStyleMerged = [
    styles.label,
    { color: textColor },
    customLabelStyle,
  ];

  return (
    <View style={containerStyle}>
      {showTitle && (
        <Text style={titleStyleMerged}>{i18n.t('Allergens')}</Text>
      )}
      <View style={styles.legendItems}>
        {legend.map((item) => (
          <View key={item.name} style={styles.legendItem}>
            <View
              style={[
                styles.circle,
                {
                  backgroundColor: item.color,
                  width: circleSize,
                  height: circleSize,
                  borderRadius: circleSize / 2,
                },
              ]}
            />
            <Text style={labelStyleMerged}>
              {translateText(item.name)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 12,
    borderRadius: 8,
    backgroundColor: 'rgba(0,0,0,0)',
  },
  title: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 8,
    backgroundColor: 'rgba(0,0,0,0)',
  },
  legendItems: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    backgroundColor: 'rgba(0,0,0,0)',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'rgba(0,0,0,0)',
  },
  circle: {
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.2)',
  },
  label: {
    fontSize: 12,
    backgroundColor: 'rgba(0,0,0,0)',
  },
});
